<div class="card card-custom">
	<div class="card-header">
		<div class="card-title">
			<p>{{isLiquidacion ? "Mandante" : isFacturaCompra ? "Proveedor" : isFacturaExportacion ? "Cliente Internacional" : "Cliente" }}</p>
		</div>
	</div>
	<div class="card-head"></div>
	<div class="card-content">
		<div class="card-body" [formGroup]="contraparteGroupForm">
			<div class="row" *ngIf="!isFacturaExportacion">
				<div class="col-md-12 col-lg-6 form-group mx-auto">
					<div class="row">
						<div class="col-lg-4 col-md-3 label-control">
							{{ isFacturaCompra ? "Rut Proveedor" : isFacturaExportacion ? "Identificador Cliente Internacional" : " Rut Cliente" }}
						</div>

						<div class="col-lg-8 col-md-9">
							<div class="input-group">
								<input
									type="text"
									name="rutBusqueda"
									placeholder="Sin ptos con guión"
									class="form-control"
									formControlName="rutBusqueda"
									maxlength="10"
									(blur)="validateRut ? buscaCliente($event.target.value) : searchClientAlternIdentifier($event.target.value)"
									[ngClass]="{
										spinner: loadingClient$ | async
									}" />

								<div class="input-group-append">
									<ng-container class="text-right" style="position: absolute; z-index: -100" *ngIf="loadingClient$ | async">
										<span class="spinner spinner-primary spinner-sm ml-5"></span>
									</ng-container>
									<button class="btn btn-outline-secondary" type="button" (click)="openClientListModal(clientListModal)" *ngIf="!isFacturaCompra && !isFacturaExportacion">
										<i class="fa fa-search"></i>
									</button>
									<!-- <button class="btn btn-outline-secondary" type="button" (click)="openClientListModal(clientListModal)" *ngIf="!isFacturaCompra">
                                        <i class="fa fa-search"></i>
                                    </button> -->
									<button class="btn btn-outline-secondary" type="button" (click)="openProveedorListModal(providerListModal)" *ngIf="isFacturaCompra">
										<i class="fa fa-search"></i>
									</button>
								</div>
							</div>

							<div *ngIf="contraparteGroupForm.controls.rutBusqueda && (contraparteGroupForm.touched || contraparteGroupForm.dirty) && contraparteGroupForm.controls.rutBusqueda.invalid" class="text-danger">
								<div *ngIf="contraparteGroupForm.controls.rutBusqueda.errors?.required">Campo Requerido</div>
								<div *ngIf="contraparteGroupForm.get('rutBusqueda').hasError('VerificacionRutValidator')">Rut no válido</div>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-12 col-lg-6 form-group mx-auto">
					<div class="row">
						<div class="col-lg-4 col-md-3 label-control">Razon Social</div>
						<div class="col-lg-8 col-md-9">
							<input type="text" class="form-control" formControlName="razonSocial" (change)="changeRazonSocial($event.target.value)"/>
						</div>
					</div>
				</div>
			</div>
			<div class="row" *ngIf="isFacturaExportacion">
				<div class="col-md-12 col-lg-6 form-group">
					<div class="row">
						<div class="col-lg-4 col-md-3 label-control">Razon Social</div>
						<div class="col-lg-8 col-md-9">
							<div class="input-group">
								<input
									type="text"
									class="form-control"
									formControlName="razonSocial"
									(keyup.enter)="searchClientAlternIdentifier($event.target.value)"
									(blur)="searchClientAlternIdentifier($event.target.value)"
									[ngClass]="{
										spinner: loadingClient$ | async
									}" />
								<div class="input-group-append">
									<button class="btn btn-outline-secondary" type="button" (click)="openInternationalClientListModal(internationalListModal)" *ngIf="isFacturaExportacion" ngbTooltip="Buscar Cliente Internacional">
										<i class="fa fa-search"></i>
									</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-12 col-lg-6 d-none d-lg-block form-group mx-auto">
					<div class="row">
						<div class="col-lg-4 col-md-3 label-control">Giro</div>
						<div class="col-lg-8 col-md-9">
							<input type="text" class="form-control" formControlName="giro" (change)="changeGiro($event.target.value)" />
						</div>
					</div>
				</div>
				<div class="col-md-12 col-lg-6 form-group mx-auto">
					<div class="row">
						<div class="col-lg-4 col-md-3 label-control">Dirección</div>
						<div class="col-lg-8 col-md-9">
							<input type="text" class="form-control" formControlName="dirFact" (change)="changeDireccion($event.target.value)" />
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-md-12 col-lg-6 form-group mx-auto">
					<div class="row">
						<div class="col-lg-4 col-md-3 label-control">{{ isFacturaExportacion ? "Estado" : "Comuna" }}</div>
						<div class="col-lg-8 col-md-9">
							<input type="text" class="form-control" formControlName="comuna" (change)="changeComuna($event.target.value)" />
						</div>
					</div>
				</div>
				<div class="col-md-12 col-lg-6 form-group mx-auto d-none d-lg-block">
					<div class="row">
						<div class="col-lg-4 col-md-3 label-control">Ciudad</div>
						<div class="col-lg-8 col-md-9">
							<input type="text" class="form-control" formControlName="ciudad" (change)="changeCiudad($event.target.value)" />
						</div>
					</div>
				</div>
			</div>
			<div class="row">
				<div
					class="col-md-12 col-lg-6 form-group mx-auto"
					[ngClass]="{
						'mx-auto': !isFacturaExportacion
					}">
					<div class="row">
						<div class="col-lg-4 col-md-3 label-control">Correo Electronico</div>
						<div class="col-lg-8 col-md-9">
							<input type="text" class="form-control" formControlName="correoFact" (change)="changeCorreoFact($event.target.value)" />
							<div *ngIf="showEmailWarning" class="text-warning mt-1" style="font-size: 15px;">
								<small>El documento será enviado al correo ingresado.</small>
							</div>
						</div>
					</div>
				</div>
				<div class="col-md-12 col-lg-6 form-group mx-auto">
					<div class="row" *ngIf="isFacturaExportacion">
						<div class="col-lg-4 col-md-3 label-control">País</div>
						<div class="col-lg-8 col-md-9">
							<input type="text" class="form-control" formControlName="pais" [attr.disabled]="editableFormControl || isFacturaCompra" />
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>

<swal #currentSwal icon="info" title="Operación" text="Operación realizada"></swal>

<!-- <swal #swalBuscandoCliente 
allowOutsideClick=false 
allowEscapeKey=false 
showConfirmButton=false 
title="Cargando" 
text="El cliente no está ingresado en la base de datos."></swal> -->

<ng-template #clientListModal let-d="dismiss" let-c="close">
	<div class="modal-lg">
		<div class="modal-body">
			<app-client-list (clientToPass)="selectedReceptor($event)"></app-client-list>
		</div>
	</div>
</ng-template>
<ng-template #providerListModal let-d="dismiss" let-c="close">
	<div class="modal-lg">
		<div class="modal-body">
			<app-client-list [ProveedorMode]="true" (clientToPass)="selectedProveedor($event)"></app-client-list>
		</div>
	</div>
</ng-template>

<ng-template #internationalListModal let-d="dismiss" let-c="close">
	<div class="modal-lg">
		<div class="modal-body">
			<app-client-list [InternationalMode]="true" (clientToPass)="selectedClienteInternacional($event)"> </app-client-list>
		</div>
	</div>
</ng-template>
